import { render, staticRenderFns } from "./Cgu.vue?vue&type=template&id=0f15a75c&scoped=true"
import script from "./Cgu.vue?vue&type=script&lang=js"
export * from "./Cgu.vue?vue&type=script&lang=js"
import style0 from "./Cgu.vue?vue&type=style&index=0&id=0f15a75c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f15a75c",
  null
  
)

export default component.exports